import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/quote/deleteQuote");

export function send(): Promise<void> {
  return fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Error when clearing quote");
      }
    })
    .then((result) => {
      window.SCHA.updateMinicart?.();
      return result;
    });
}
